module.exports = __webpack_public_path__ + "static/img/ios2.35786def.webp";